import React from "react";
import Hero from "../Components/Hero/Hero";
import CoursesAbout from "../Components/CoursesAbout/CoursesAbout";
const Courses = () => {
  return (
    <div className="home_page">
      <Hero />
      <CoursesAbout />
    </div>
  );
};

export default Courses;
